import "./vendor/phone-input.js";
import "./vendor/lazy-img.js";
import "./vendor/lazy-bg.js";
